import { Button, Text, Box, Input } from "@chakra-ui/react";
import WithAuth from "../components/hoc/with-auth";
import { AuthLayout } from "../components/layouts";
import { LayoutWithSidebar } from "../components/layouts/layout-with-sidebar.tsx";
import DealsPage from "../components/pages/deals-page/index";
import PositionPage from "../components/pages/positions-page";
import SummariesPage from "../components/pages/summaries-page";

const Summaries = () => {
  return (
    <>
      <WithAuth>
        <LayoutWithSidebar
          pageTitle="Summaries"
          pageDesc="List of all the summaries"
        >
          <SummariesPage />
        </LayoutWithSidebar>
      </WithAuth>
    </>
  );
};

export default Summaries;
